var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-wrapper"},[_vm._t("default"),(_vm.text)?_c('div',{staticClass:"badge"},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }